import { ExternalId } from './ExternalId'
import camelcaseKeys from 'camelcase-keys'
export class GuestType {
  constructor (params = {}) {
    const {
      id,
      name,
      externalIds,
      attributes,
    } = camelcaseKeys(params, { deep: true })
    this.id = id || null
    this.name = name || null
    this.atttributes = attributes || null
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
  }
}
